/* Supra quick view: copies a card's <template> into one shared dialog, handles option, price, image and quantity changes.
   Adding to cart goes through Horizon's own product-form-component, so the cart count and cart drawer update as usual. */
(function () {
  'use strict';

  var root = document.documentElement;

  function setLabel(button, text) {
    for (var i = 0; i < button.childNodes.length; i++) {
      var node = button.childNodes[i];
      if (node.nodeType === 3 && node.textContent.trim()) {
        node.textContent = text;
        return;
      }
    }
  }

  function setup(body) {
    var dataNode = body.querySelector('script[data-sg-qv-variants]');
    var form = body.querySelector('form');
    if (!dataNode || !form) return;

    var variants = [];
    try {
      variants = JSON.parse(dataNode.textContent);
    } catch (e) {}

    var idInput = form.querySelector('input[name=id]');
    var button = form.querySelector('button[type=submit]');
    var priceNode = body.querySelector('[data-sg-qv-price]');
    var noteNode = body.querySelector('[data-sg-qv-note]');
    var mainImage = body.querySelector('[data-sg-qv-image]');
    var groups = body.querySelectorAll('[data-sg-qv-option]');

    function showImage(src) {
      if (!mainImage || !src) return;
      mainImage.removeAttribute('srcset');
      mainImage.removeAttribute('sizes');
      mainImage.src = src;
    }

    function selection() {
      var values = [];
      for (var i = 0; i < groups.length; i++) {
        var checked = groups[i].querySelector('input:checked');
        values.push(checked ? checked.value : null);
      }
      return values;
    }

    function match(values) {
      for (var i = 0; i < variants.length; i++) {
        var ok = true;
        for (var j = 0; j < values.length; j++) {
          if (variants[i].options[j] !== values[j]) {
            ok = false;
            break;
          }
        }
        if (ok) return variants[i];
      }
      return null;
    }

    function renderPrice(variant) {
      if (!priceNode || !variant) return;
      priceNode.textContent = '';
      if (variant.compare) {
        var old = document.createElement('s');
        old.textContent = variant.compare;
        priceNode.appendChild(old);
      }
      var now = document.createElement('span');
      now.textContent = variant.price;
      priceNode.appendChild(now);
    }

    function apply() {
      if (!groups.length) return;
      var variant = match(selection());
      if (variant) {
        if (idInput) idInput.value = variant.id;
        renderPrice(variant);
        if (button) {
          button.disabled = !variant.available;
          setLabel(button, variant.available ? 'Add to cart' : 'Sold out');
        }
        if (noteNode) noteNode.textContent = '';
        showImage(variant.image);
      } else {
        if (button) {
          button.disabled = true;
          setLabel(button, 'Unavailable');
        }
        if (noteNode) noteNode.textContent = 'This combination is not available.';
      }
    }

    for (var g = 0; g < groups.length; g++) groups[g].addEventListener('change', apply);

    var thumbs = body.querySelectorAll('[data-sg-qv-thumb]');
    for (var t = 0; t < thumbs.length; t++) {
      thumbs[t].addEventListener('click', function (event) {
        showImage(event.currentTarget.getAttribute('data-sg-qv-thumb'));
      });
    }

    var qty = form.querySelector('input[name=quantity]');
    var steppers = body.querySelectorAll('[data-sg-qty]');
    for (var s = 0; s < steppers.length; s++) {
      steppers[s].addEventListener('click', function (event) {
        if (!qty) return;
        var step = parseInt(event.currentTarget.getAttribute('data-sg-qty'), 10) || 0;
        var next = (parseInt(qty.value, 10) || 1) + step;
        qty.value = String(Math.max(1, Math.min(99, next)));
      });
    }
  }

  function open(card) {
    var dialog = document.getElementById('sg-qv');
    var template = card.querySelector('template[data-sg-qv-template]');
    if (!dialog || !template) return;
    var body = dialog.querySelector('[data-sg-qv-body]');
    body.replaceChildren(template.content.cloneNode(true));
    setup(body);
    dialog.showModal();
    root.setAttribute('scroll-lock', '');
    dialog.scrollTop = 0;
  }

  function close() {
    var dialog = document.getElementById('sg-qv');
    if (dialog && dialog.open) dialog.close();
  }

  document.addEventListener('click', function (event) {
    var target = event.target;
    if (!target || !target.closest) return;

    var trigger = target.closest('[data-sg-qv-open]');
    if (trigger) {
      var card = trigger.closest('.sg-card');
      if (card) open(card);
      return;
    }

    if (target.closest('[data-sg-qv-close]') || target.id === 'sg-qv') close();
  });

  /* Close after Add so the cart drawer can open on top */
  document.addEventListener('submit', function (event) {
    var dialog = document.getElementById('sg-qv');
    if (dialog && dialog.open && dialog.contains(event.target)) window.setTimeout(close, 60);
  });

  document.addEventListener(
    'close',
    function (event) {
      if (event.target && event.target.id === 'sg-qv') root.removeAttribute('scroll-lock');
    },
    true
  );
})();
